import * as Yup from "yup";

export const onboardingObject = {
  connectionID: "",
  brandID: "",
  brandName: "",
  connectionUrl: "",
  status: "",
  token: "",
  mappedFields: [],
  fieldNames: "",
  connection: false,
  csvUpload: false,
  requestHeaders: "",
  apiUrl: "",
  additionalFields: [],
};

export function objectFromFormData(formData, mappedFields) {
  return {
    brand_id: formData.brandID,
    connectionDetails: {
      platform_ids: formData.platforms,
      status: formData.status,
      ...(formData.onboardingType === "NODE" && {
        csv_upload: formData.csvUpload,
      }),
      ...(formData.onboardingType === "NODE" && {
        primeIdentifiers: {
          prime_identifier: { mobile: formData.mobile },
          other_identifier: {
            email: formData.email,
            gaid: formData.gaid,
          },
        },
      }),
      ...(formData.connectionUrl && { connection_url: formData.connectionUrl }),
      ...(formData.token && { token: formData.token }),
      ...(formData.apiUrl && { api_url: formData.apiUrl }),
      ...(formData.requestBody && { request_body: formData.requestBody }),
      ...(formData.requestHeaders && {
        request_sample: formData.requestHeaders,
      }),
    },
    ...(formData.mappedFields?.length > 0 && { fieldMappings: mappedFields }),
    ...(formData.additional_fields?.length > 0 && {
      additional_fields: formData.additionalFields || [],
    }),
  };
}

export function objectFromResponse(responseData) {
  return {
    apiUrl: responseData.connectionDetails?.api_url,
    requestHeaders: responseData.connectionDetails?.request_sample,
    requestBody: responseData.connectionDetails?.request_body,
    onboardingType: responseData.connectionDetails?.type_method,
    additionalFields: responseData.additional_fields || [],
    status: responseData.connectionDetails?.status,
    brandDetails: responseData.brandDetails,
    fieldNames: responseData.fieldsNames || "",
    connection: responseData.connection || false,
    token: responseData.connectionDetails?.token,
    csvUpload: responseData.brandDetails?.csv_upload || false,
    brandID: responseData.connectionDetails?.brand_id,
    brandName: responseData.brandDetails?.brand_name,
    platforms: responseData.connectionDetails?.platform_ids,
    connectionID: responseData.connectionDetails?.connection_id,
    connectionUrl: responseData.connectionDetails?.connection_url,
    email:
      responseData.connectionDetails?.primeIdentifiers?.other_identifier?.email,
    mobile:
      responseData.connectionDetails?.primeIdentifiers?.prime_identifier
        ?.mobile,
    gaid: responseData.connectionDetails?.primeIdentifiers?.other_identifier
      ?.gaid,
  };
}

export function setValue(responseData, fieldsMapped) {
  let values = {};
  let returnValue = {};
  if (responseData.fieldMappings.length > 0) {
    for (let field of responseData.fieldMappings) {
      values[field.field_value] = {
        value: field.field_name,
        type: field.field_type,
        value_type: field.value_type,
        priority: field.field_priority,
        org_trust: field.field_org_trust,
        cpm_price: field.field_cpm_price,
        field_additional_info: field.field_additional_info,
      };
    }
  }

  for (let field of fieldsMapped) {
    if (values[field.field_name] !== undefined) {
      returnValue[field.field_name] = {
        value: values[field.field_name].value,
        type: values[field.field_name].type,
        value_type: values[field.field_name].value_type,
        priority: values[field.field_name].priority,
        org_trust: values[field.field_name].org_trust,
        cpm_price: values[field.field_name].cpm_price,
        field_additional_info: values[field.field_name].field_additional_info,
      };
    }
  }
  return returnValue;
}

// Helper to validate requestHeaders as JSON
// const jsonTest = Yup.string().test(
//   "is-json",
//   "Request headers must be valid JSON",
//   (value) => {
//     if (!value) return false;
//     try {
//       JSON.parse(value);
//       return true;
//     } catch {
//       return false;
//     }
//   }
// );

export const validationSchema = Yup.object().shape({
  brandID: Yup.string().required("Brand name is required"),

  csvUpload: Yup.boolean(),

  onboardingType: Yup.string()
    .oneOf(["NODE", "API"], "Onboarding Type must be either 'NODE' or 'API'")
    .required("Onboarding Type is required"),

  mobile: Yup.string().when("onboardingType", {
    is: "NODE",
    then: (schema) =>
      schema
        .matches(/^[a-zA-Z_]+$/, "It only accepts letters and underscores")
        .required("This prime identifier is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  email: Yup.string().matches(
    /^[a-zA-Z_]+$/,
    "It only accepts letters and underscores"
  ),

  gaid: Yup.string().matches(
    /^[a-zA-Z_]+$/,
    "It only accepts letters and underscores"
  ),

  connectionUrl: Yup.string().when(["csvUpload", "onboardingType"], {
    is: (csvUpload, onboardingType) =>
      csvUpload === false && onboardingType === "NODE",
    then: (schema) =>
      schema
        .matches(
          /^((https?:\/\/)|(www\.))(?:([a-zA-Z]+)|(\d+\.\d+\.\d+\.\d+)):\d{4}$/,
          "Enter correct url!"
        )
        .required("IP/Domain Url is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  token: Yup.string().when(["csvUpload", "onboardingType"], {
    is: (csvUpload, onboardingType) =>
      csvUpload === false && onboardingType === "NODE",
    then: (schema) =>
      schema
        .matches(/(^[\w-]*\.[\w-]*\.[\w-]*$)/, "It must be a valid JWT token")
        .required("Token is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  apiUrl: Yup.string().when("onboardingType", {
    is: "API",
    then: (schema) =>
      schema.url("Must be a valid API URL").required("API Url is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  requestHeaders: Yup.string().when("onboardingType", {
    is: "API",
    then: (schema) => schema.required("Request Header is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
